import { Component, OnChanges, ViewChildren, QueryList, ElementRef, Input } from '@angular/core';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from 'src/app/shared/widgets/value-accessors/object-value-accessor';
import { ProfileService } from '../../shared/profile.service';
import { SocialMedia } from '../../shared/social-media.model';
import { SocialMediaType } from '../../shared/social-media-type';

@Component({
  selector: 'wl-profile-edit-social-media',
  templateUrl: './profile-edit-social-media.component.html',
  styleUrls: ['./profile-edit-social-media.component.css'],
  providers: [
    CreateObjectValueAccessorProvider(ProfileEditSocialMediaComponent),
    CreateObjectValueValidationProvider(ProfileEditSocialMediaComponent),
  ],
    standalone: false
})
export class ProfileEditSocialMediaComponent extends ObjectValueAccessor<Array<SocialMedia>> implements OnChanges {
  @Input() profileId: number;
  @ViewChildren('socialMediaInputs') socialMediaInputs: QueryList<ElementRef>;

  public socialMediaTypes = new Array<SocialMediaType>();
  private _iconMap = {
    angieslist: 'sn-angieslist.svg',
    facebook: 'facebook.svg',
    flickr: 'sn-flickr.svg',
    foursquare: 'sn-foursquare.svg',
    houzz: 'sn-houzz.svg',
    instagram: 'instagram.svg',
    linkedin: 'linkedin.svg',
    opentable: 'sn-opentable.svg',
    pinterest: 'sn-pinterest.svg',
    tripadvisor: 'sn-tripadvisor.svg',
    twitter: 'x.svg',
    yelp: 'sn-yelp.svg',
    youtube: 'youtube.svg',
  };

  constructor(private _profileService: ProfileService) {
    super([], false);
  }

  ngOnChanges() {
    if (this.profileId) {
      this._profileService.getProfileSocialMedia(this.profileId).then(data => {
        this.value = data;
        this._profileService.getSocialMediaTypes().then(data2 => {
          this.socialMediaTypes = data2;
          this.value.forEach(item => {
            this.socialMediaTypes = this.socialMediaTypes.filter(type => {
              return type.SocialMediaTypeID !== item.SocialMediaTypeID;
            });
          });
        });
        setTimeout(() => {
          this.setPristine();
        }, 500);
      });
    }
  }

  mapToIconAsset(socialMediaName: string) {
    const normalizedName = socialMediaName
      .toLowerCase()
      .replace("'", '')
      .replace(' ', '');
    const assetName = this._iconMap[normalizedName];
    return `/assets/img/social-media-icons/${assetName}`;
  }

  getSocialMediaTypeById(id: number) {
    return this.socialMediaTypes.find(x => x.SocialMediaTypeID === id);
  }

  onSelectSocialMediaType(event) {
    const selectedTypeId = parseInt(event.target.value, 10);
    this.addSocialMedia(selectedTypeId);
  }

  deleteSocialMedia(socialMediaTypeId: number) {
    const socialMedia = this.value.find(item => {
      return item.SocialMediaTypeID === socialMediaTypeId;
    });
    this.socialMediaTypes.push(socialMedia.SocialMediaType);
    this.value = this.value.filter(item => {
      return item.SocialMediaTypeID !== socialMediaTypeId;
    });
  }

  removeSocialMediaType(socialMediaTypeId: number) {}

  sortedSocialMedias() {
    return this.value.sort((a, b) => {
      return a.SocialMediaType.Name < b.SocialMediaType.Name ? -1 : a.SocialMediaType.Name > b.SocialMediaType.Name ? 1 : 0;
    });
  }

  sortedSocialMediaTypes() {
    return this.socialMediaTypes.sort((a, b) => {
      return a.Name < b.Name ? -1 : a.Name > b.Name ? 1 : 0;
    });
  }

  save() {
    const unchangedSocialMedias: Array<SocialMedia> = JSON.parse(this.pristineValue);
    const deletedSocialMedias: Array<SocialMedia> = unchangedSocialMedias.filter(
      x => !this.value.some(a => x.SocialMediaID == a.SocialMediaID)
    );
    const socialMediaPromises: any[] = [];

    for (let socialMedia of this.value) {
      if (socialMedia.SocialMediaID > 0) {
        const originalEmail: SocialMedia = unchangedSocialMedias.find(x => x.SocialMediaID == socialMedia.SocialMediaID);
        if (originalEmail && JSON.stringify(originalEmail) != JSON.stringify(socialMedia)) {
          socialMediaPromises.push(this._profileService.updateSocialMedia(socialMedia));
        }
      }

      if (!socialMedia.SocialMediaID) {
        socialMedia.ProfileID = this.profileId;
        socialMediaPromises.push(
          this._profileService.createSocialMedia(socialMedia).then(data => {
            socialMedia.SocialMediaID = data;
          })
        );
      }
    }

    for (let socialMedia of deletedSocialMedias) {
      socialMediaPromises.push(this._profileService.deleteSocialMedia(socialMedia.SocialMediaID));
    }

    return Promise.all(socialMediaPromises).then(() => {
      this.setPristine();
    });
  }

  private addSocialMedia(mediaTypeId: number) {
    const socialMediaType = this.getSocialMediaTypeById(mediaTypeId);

    this.value.push({
      SocialMediaTypeID: socialMediaType.SocialMediaTypeID,
      ProfileID: this.profileId,
      SocialMediaType: socialMediaType,
    } as SocialMedia);

    this.socialMediaTypes = this.socialMediaTypes.filter(x => {
      return x.SocialMediaTypeID !== mediaTypeId;
    });
    setTimeout(() => {
      let addedSocialMedia = this.socialMediaInputs.find(item => {
        return item.nativeElement.id === `sm-${socialMediaType.SocialMediaTypeID}`;
      });
      addedSocialMedia.nativeElement.focus();
    }, 500);
  }
}
